<!--修改用户-->
<template>
  <div v-loading="loading" class="payment-account-user">
    <div class="module">
      <h5 class="module-title">修改用户</h5>
      <el-form
        ref="ruleForm"
        :model="ruleForm"
        :rules="rules"
        label-width="100px"
        class="demo-ruleForm"
      >
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="用户名称：" prop="name" label-width="96px">
              {{ defaultForm.realName }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="支付平台账号："
              prop="region"
              label-width="121px"
            >
              {{ defaultForm.paycenterLoginAccount }}
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item
              label="邮箱地址："
              prop="email"
              :rules="rules.email"
              label-width="96px"
            >
              <el-input
                v-model="ruleForm.email"
                placeholder="请输入邮箱地址"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="手机号码："
              prop="mobile"
              :rules="rules.mobile"
              label-width="121px"
            >
              <el-input
                v-model="ruleForm.mobile"
                placeholder="请输入手机号码"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-show="showVerifyCode" :gutter="20">
          <el-col :span="12">
            <el-form-item
              label="图形验证码："
              prop="imageCode"
              :rules="rules.imageCode"
              class="graphical-code"
              label-width="96px"
            >
              <el-input
                v-model="ruleForm.imageCode"
                placeholder="请输入图形验证码"
              ></el-input>
              <div class="graphical-code-button">
                <img :src="graphicalSrc" alt="" />
                <el-button
                  type="text"
                  size="small"
                  @click="getGraphicalVerficationCode"
                  >换一张
                </el-button>
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="短信验证码："
              prop="smsCode"
              :rules="rules.smsCode"
              label-width="121px"
              class="message-code"
            >
              <el-input
                v-model="ruleForm.smsCode"
                placeholder="请输入短信验证码"
              ></el-input>
              <el-button
                type="text"
                size="small"
                :disabled="verfityCodeDisalbed"
                @click="getMessageVerficationCode"
                >{{ verfityCode }}
              </el-button>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item
              label="用户权限："
              prop="role"
              :rules="rules.role"
              label-width="96px"
            >
              <el-checkbox-group v-model="ruleForm.role">
                <el-checkbox label="F002" :disabled="roleDisabled"
                  >经办</el-checkbox
                >
                <el-checkbox label="F003" :disabled="roleDisabled"
                  >审核</el-checkbox
                >
                <el-checkbox
                  v-if="[true, 'true'].includes($route.query?.showQueryRole)"
                  label="F004"
                  :disabled="roleDisabled"
                  >查询</el-checkbox
                >
              </el-checkbox-group>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <!--      申请人信息-->
    <applicant-info ref="applicantInfo"></applicant-info>
    <div style="margin-top: 20px" class="footer-button">
      <eui-btn type="secondary" @click="handleConfirmReturn">返 回</eui-btn>
      <div>
        <eui-btn type="weak" @click="handleConfirmReturn">取 消</eui-btn>
        <eui-btn type="primary" @click="handleSubmit">提 交</eui-btn>
      </div>
    </div>
  </div>
</template>

<script>
import Api from '@/modules/projectA/api/paymentAccount/index';
import { emailReg, mobileReg } from '@/modules/projectA/utils/verification';
import bus from '@/components/common/bus';
import _ from 'lodash';
import ApplicantInfo from './applicantInfo';

export default {
  name: 'AddUser',
  components: { ApplicantInfo },
  mixins: [],
  data() {
    return {
      loading: false,
      defaultForm: {
        realName: '',
        paycenterLoginAccount: '',
        mobile: '', // 手机号码备份
      },
      ruleForm: {
        email: '',
        mobile: '',
        role: [],
        userId: '',
        imageCode: '',
        smsCode: '',
        messageId: '',
        changeMultipleMode: false,
      },
      rules: {
        mobile: [
          {
            required: true,
            validator: async (rule, value, callback) => {
              if (!mobileReg.test(value)) {
                callback(new Error('请输入正确的手机号'));
              } else {
                const res = await Api.checkEpayAccountUserMobileUnique({
                  mobile: value,
                  userId: this.ruleForm.userId,
                });
                if (res.code === '200' && !res.data.status) {
                  callback(res.data.msg);
                }
              }
              callback();
            },
            trigger: 'blur',
          },
        ],
        email: [
          {
            required: true,
            validator: async (rule, value, callback) => {
              if (!emailReg.test(value)) {
                callback(new Error('请输入正确的邮箱地址'));
              } else {
                const res = await Api.checkEpayAccountUserEmailUnique({
                  email: value,
                  userId: this.ruleForm.userId,
                });
                if (res.code === '200' && !res.data.status) {
                  callback(res.data.msg);
                }
                callback();
              }
            },
            trigger: 'blur',
          },
        ],
        role: [
          {
            required: true,
            validator: async (rule, value, callback) => {
              if (!value.length) {
                callback(new Error('请选择用户权限'));
              } else if (
                value.includes('F002') &&
                value.includes('F003') &&
                !this.roleDisabled
              ) {
                callback(new Error('不能同时选择经办和审核'));
              } else if (!this.roleDisabled) {
                // 验证经办或审核人数不能超过3人（含本次选择）
                // 当前企业必须至少有一个经办人员和一个审核人员
                const res = await Api.modifyEpayAccountUserRoleCheck({
                  changeMultipleMode: this.ruleForm.changeMultipleMode,
                  userId: this.ruleForm.userId,
                  role: value.join(','),
                });
                if (res.code === '200' && !res.data.status) {
                  callback(res.data.msg);
                }
              }
              callback();
            },
            trigger: 'change',
          },
        ],
        imageCode: [
          { required: false, message: '请输入图形验证码', trigger: 'blur' },
        ],
        smsCode: [
          { required: false, message: '请输入短信验证码', trigger: 'blur' },
        ],
      },
      graphicalSrc: '@/assets/img/paymenAccount/placeholder.png',
      verfityCode: '获取验证码',
      verfityCodeDisalbed: false,
      waitTime: 60,
      roleDisabled: false, // 用户权限是否可编辑
    };
  },
  computed: {
    // 手机号发生变更，需要进行新手机号短信验证码校验。显示图形验证码和短信验证码字段。
    showVerifyCode() {
      const showFlag = this.ruleForm.mobile !== this.defaultForm.mobile;
      this.changeReuired(showFlag);
      return showFlag;
    },
  },
  created() {
    if (this.$route?.query) {
      const routeParams = this.$route.query;
      if (['false', false].includes(routeParams.changeMultipleMode)) {
        this.ruleForm.changeMultipleMode = false;
      } else {
        this.ruleForm.changeMultipleMode = true;
      }
      this.ruleForm.userId = routeParams?.userId;
      if (['false', false].includes(routeParams.roleDisabled)) {
        this.roleDisabled = false;
      } else {
        this.roleDisabled = true;
      }
    }
    this.initData();
    this.getGraphicalVerficationCode();
  },
  methods: {
    async initData() {
      const res = await Api.getEpayAccountUser({
        userId: this.ruleForm.userId,
      });
      if (res.code === '200') {
        this.defaultForm.realName = res.data?.realName;
        this.defaultForm.paycenterLoginAccount =
          res.data?.paycenterLoginAccount;
        this.defaultForm.mobile = res.data?.mobile;
        Object.keys(this.ruleForm).forEach((key) => {
          if (key === 'changeMultipleMode') {
            return;
          }
          if (key === 'role') {
            this.$set(this.ruleForm, 'role', res.data[key]?.split(',') ?? []);
          } else {
            this.ruleForm[key] = res.data[key];
          }
        });
      }
    },
    // 获取图形验证码
    async getGraphicalVerficationCode() {
      const res = await Api.getEpaySettleAccountUkeyImageCode();
      if (res.code === '200') {
        this.graphicalSrc = res.data;
      }
    },
    // 获取短信验证码
    async getMessageVerficationCode() {
      // 1、需要校验图形验证码是否正确；2、需要验证手机号格式是否正确
      if (!this.ruleForm.imageCode) {
        this.$message.warning('请输入图形验证码');
        return;
      }
      if (!mobileReg.test(this.ruleForm.mobile)) {
        this.$message.warning('请输入正确的手机号');
        return;
      }
      const res = await Api.sendEpaySettleAccountUkeySMS({
        imageCode: this.ruleForm.imageCode,
        mobile: this.ruleForm.mobile,
      });
      if (res.code === '200') {
        this.ruleForm.messageId = res.data;
        this.messageCountdown();
      }
    },
    // 短信验证码倒计时
    messageCountdown() {
      if (this.waitTime === 0) {
        this.verfityCode = '获取验证码';
        this.waitTime = 60;
        this.verfityCodeDisalbed = false;
      } else {
        this.verfityCodeDisalbed = true;
        this.verfityCode = `${this.waitTime}s后重新发送`;
        this.waitTime--;
        setTimeout(() => {
          this.messageCountdown();
        }, 1000);
      }
    },
    // 提交
    async handleSubmit() {
      const formName = ['applicantInfo'];
      const validates = (item) => {
        return new Promise((resolve, reject) => {
          if (!this.$refs[item]?.$refs.ruleForm) {
            reject();
          }
          this.$refs[item].$refs.ruleForm.validate((valid) => {
            if (valid) {
              resolve();
            }
          });
        });
      };
      const userForm = new Promise((resolve) => {
        this.$refs.ruleForm.validate((valid) => {
          if (valid) {
            resolve();
          }
        });
      });
      Promise.all([userForm, ...formName.map((item) => validates(item))]).then(
        () => {
          this.handleSave();
        }
      );
    },
    // 保存
    async handleSave() {
      const params = {
        ..._.cloneDeep(this.$refs.applicantInfo.ruleForm),
        ...this.ruleForm,
        role: this.ruleForm.role?.join(','),
      };
      params.accountUserApplicantAttachAOList.forEach((item) => {
        // 申请人证件
        if (item.attachType === 'AC') {
          item.certificateValidityBegin = item.certificateTimeRange?.[0];
          item.certificateValidityEnd = item.certificateTimeRange?.[1];
          delete item.certificateTimeRange;
        }
        item.isLongTernEffective = item.isLongTernEffective ? 1 : 0;
      });
      console.log(params, 'params');
      Api.modifyEpayAccountUser(params).then((res) => {
        if (res.code === '200') {
          this.$message.success('修改成功');
          this.handleReturn();
        }
      });
    },
    changeReuired(flag) {
      this.$set(this.rules.imageCode[0], 'required', flag);
      this.$set(this.rules.smsCode[0], 'required', flag);
    },
    handleConfirmReturn() {
      this.$confirm('是否取消修改用户申请操作，点击确认关闭当前弹窗', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        this.handleReturn();
      });
    },
    handleReturn() {
      bus.$emit('close_current_tags');
      this.$router.replace('/paymentAccount');
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../css/common.scss';
</style>
